import React, { useState } from "react";

//import scss
import "./Mid-Section-Pc.scss";


//import icons
import { MdWaterDrop } from "react-icons/md";
import { PiHouseLineDuotone } from "react-icons/pi";
import { BiReceipt } from "react-icons/bi";
import { LiaFileInvoiceSolid } from "react-icons/lia";
import InvoiceReportComponent from "./Invoice-Report-Component";
import RecentInvoicesTableComponent from "./Recent-Invoices-Table-Component";
import WaterInvoices from "./WaterInvoices";
import RentInvoices from "./RentInvoice";
import CreateInvoicesPage from "./ViewWaterInvoices";
import InvoiceTable from "./ViewInvoices";

const MidSectionInvoicesPc = () => {
  const [invoiceTypeSelected, setInvoiceTypeSelected] = useState(null);
  const [invoiceFilters, setInvoiceFilters] = useState(null);
  const handleNavigateToPage = (page, filters = null) => {
    setInvoiceFilters(filters);
    setInvoiceTypeSelected(page);
  };

  const invoices = [
    {
      id: "1",
      type: "rent",
      date: "2024-02-01",
      dueDate: "2024-02-10",
      amount: 1200,
      status: "paid",
      reference: "INV-001",
    },
    {
      id: "2",
      type: "water",
      date: "2024-02-05",
      dueDate: "2024-02-15",
      amount: 50,
      status: "pending",
      reference: "INV-002",
    },
    {
      id: "3",
      type: "rent",
      date: "2024-02-10",
      dueDate: "2024-02-20",
      amount: 1300,
      status: "overdue",
      reference: "INV-003",
    },
  ];

  return (
    <>
      {!invoiceTypeSelected && (
        <>
          <div className="mid-section-invoices-pc-admin">
            <div className="top-section-invoices">
              <div className="left-top">
                <div className="main-heading">Manage All Your Invoices</div>
                <div className="sub-heading">
                  Create,View and Update all invoices
                </div>
              </div>
              <div className="right-top">
                <div
                  className="card"
                  onClick={() => handleNavigateToPage("Water")}
                >
                  <div className="top">
                    <div className="number">01</div>
                  </div>
                  <div className="bottom">
                    <div className="icon">
                      <MdWaterDrop />
                    </div>
                    <div className="heading">Water Invoices</div>
                    <div className="value">200</div>
                  </div>
                </div>
                <div
                  className="card"
                  style={{ backgroundColor: "#64A371" }}
                  onClick={() => handleNavigateToPage("Rent")}
                >
                  <div className="top">
                    <div className="number">02</div>
                  </div>
                  <div className="bottom">
                    <div className="icon">
                      <PiHouseLineDuotone />
                    </div>
                    <div className="heading">Rent Invoices</div>
                    <div className="value">200</div>
                  </div>
                </div>
                <div
                  className="card"
                  // style={{ backgroundColor: "#377771" }}
                  onClick={() => handleNavigateToPage("Create")}
                >
                  <div className="top">
                    <div className="number">03</div>
                  </div>
                  <div className="bottom">
                    <div className="icon">
                      <BiReceipt />
                    </div>
                    <div className="heading">View water invoices</div>
                    <div className="value">200</div>
                  </div>
                </div>
                <div
                  className="card"
                  style={{ backgroundColor: "#64A371" }}
                  onClick={() => handleNavigateToPage("View")}
                >
                  <div className="top">
                    <div className="number">04</div>
                  </div>
                  <div className="bottom">
                    <div className="icon">
                      <LiaFileInvoiceSolid />
                    </div>
                    <div className="heading">View rent Invoices</div>
                    <div className="value">200</div>
                  </div>
                </div>
              </div>
            </div>

          
            <div className="bottom-section-invoices">
              <div className="left-bottom">
                <InvoiceReportComponent />
              </div>
              <div className="right-bottom">
                <RecentInvoicesTableComponent />
              </div>
            </div>
          </div>
        </>
      )}
      {invoiceTypeSelected === "Water" && (
        <>
          <WaterInvoices
            initialFilters={invoiceFilters}
            onNavigateToPage={handleNavigateToPage}
          />
        </>
      )}
      {invoiceTypeSelected === "Rent" && (
        <>
          <RentInvoices initialFilters={invoiceFilters} onNavigateToPage={handleNavigateToPage} />
        </>
      )}
      {invoiceTypeSelected === "Create" && (
        <>
          <CreateInvoicesPage />
        </>
      )}
      {invoiceTypeSelected === "View" && (
        <>
          <InvoiceTable invoices={invoices} onNavigateToPage={handleNavigateToPage} />
        </>
      )}
    </>
  );
};

export default MidSectionInvoicesPc;
